import { takeLatest, put, select } from 'redux-saga/effects';
import { PCStoreJsBridge } from '../nativeapi';
import {
  GET_LOCALMACHINEINFO_START,
  GET_LOCALMACHINEINFO_SUCCESS,
  GET_LOCALSOFT_START,
  GET_LOCALSOFT_SUCCESS,
  REQUEST_NATIVE_INSTALL,
  REQUEST_NATIVE_INSTALL_LIST,
  REQUEST_NATIVE_UNINSTALL,
  SILENT_SOFT_INSTALL_INFOS_START,
  SILENT_SOFT_INSTALL_INFOS_SUCCESS,
} from '../constants/native';
import { ANDROID_APP_BATCH_DETAILS, SILENT_INSTALL_SOFT_53 } from '../config';
import { DOWNLOAD_FAILED } from '../constants/softstatus';
import { addDownload } from '../actions/download';
import { createAxios, logNative } from '../utils/utils';
import { cacheKeys } from '../constants/storageKeys';

function* fetchLocalMachineInfo() {
  try {
    const result = yield PCStoreJsBridge.getLocalMachineInfo();
    yield put({ type: GET_LOCALMACHINEINFO_SUCCESS, payload: result });
  } catch (error) {
    // throw error;
  }
}

/**
 * 获取本地安装的软件
 * 请求一：首先查询电脑是否打开VT模式true/false
 * false，
 *    请求二：获取PC本地安装列表
 *    请求三：获取PC本地更新列表
 * true
 *    请求二：获取PC本地安装列表
 *    请求三：获取安卓本地安装列表(简洁版)
 *    请求四：获取安卓本地安装列表应用详情并整合
 *    请求五：获取PC安卓本地更新列表
 */
function* fetchLocalSofts() {
  try {
    const axios = yield createAxios();
    const retAnd = [];
    let retPC = [];
    let result = [];

    let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE);
    if (vt === null) {
      const isVTEnable = yield PCStoreJsBridge.getIsVTEabled();
      vt = isVTEnable.vt ? '1' : '0';
      localStorage.setItem(cacheKeys.IS_VT_ENABLE, vt);
    }

    if (vt === '1') {
      // 获取PC本地安装列表
      retPC = yield PCStoreJsBridge.getLocalInstalledSoft();
      // 获取安卓本地安装列表(简洁版)
      const retA = yield PCStoreJsBridge.getLocalInstalledAndroidSoft();
      const params = [];
      retA.forEach(item => {
        params.push({ packageName: item.pkg, versionCode: item.vc });
      });
      if (params.length > 0) {
        // 获取安卓本地安装列表应用详情并整合
        const retAD = yield axios.post(ANDROID_APP_BATCH_DETAILS, [...params]);
        if (
          retAD.data &&
          retAD.data.status === 0 &&
          retAD.data.data &&
          retAD.data.data.length > 0
        ) {
          retAD.data.data.forEach(item => {
            const find = retA.find(v => v.pkg === item.packageName);
            retAnd.push({
              ...item,
              displayName: item.softName,
              publisher: item.developerName,
              installdate: find.instTime,
              estimateSize: find.size,
            });
          });
        }
      }
      // 获取PC安卓本地更新列表
      yield PCStoreJsBridge.getAndroidPCUpdateSoft();
      result = [...retAnd, ...retPC];
      logNative(
        `获取本地列表(安卓、PC) 总耗时: ${+new Date() - window.getUpdateStartTime}, retA: ${
          retA.length
        }, params: ${JSON.stringify(params)}, retAnd: ${retAnd.length}, PC: ${retPC.length}`,
        { retA, retAnd, all: [...retAnd, ...retPC] },
        true,
        true,
      );
    } else {
      // 获取PC本地安装列表
      retPC = yield PCStoreJsBridge.getLocalInstalledSoft();
      // 获取PC本地更新列表
      // yield PCStoreJsBridge.getUpdateSoft();
      yield PCStoreJsBridge.getAndroidPCUpdateSoft();
      result = [...retAnd, ...retPC];

      logNative(
        `获取本地列表(PC) 只有PC 总耗时: ${+new Date() -
          window.getUpdateStartTime}, retA: 0, retAnd: 0, PC: ${retPC.length}
          ${JSON.stringify(retPC)}`,
        { retA: [], retAnd, all: [...retAnd, ...retPC] },
        true,
        true,
      );
    }
    result.sort((a, b) => Number(b.installdate) - Number(a.installdate));
    yield put({ type: GET_LOCALSOFT_SUCCESS, payload: result });
  } catch (error) {
    logNative(`获取本地列表 fetchLocalSofts ${error}`, error);
  }
}

/**
 * 安装单个应用
 * @param {*} param0
 */
function* requestNativeInstall({ soft }) {
  try {
    const softs = yield select(state => state.download.softs);
    const found = softs.find(v => v.softID === soft.softID);
    if (found) {
      if (found.status === DOWNLOAD_FAILED) {
        yield put(addDownload(soft));
        yield PCStoreJsBridge.installSoft({ ...soft, isClick: 'click_retry' });
      }
    } else {
      // 走正常下载
      yield put(addDownload(soft));
      yield PCStoreJsBridge.installSoft(soft);
    }
  } catch (error) {
    logNative(`安装应用 requestNativeInstall 错误 ${error}`, error);
  }
}

/**
 * 批量安装应用
 * @param {*} param0
 */
function* requestNativeInstallList({ softList }) {
  if (softList.length > 0) {
    for (let i = 0; i < softList.length; i += 1) {
      yield requestNativeInstall({ soft: softList[i] });
    }
  }
}

function* requestNativeUninstall({ soft }) {
  try {
    yield PCStoreJsBridge.uninstallSoft(soft);
  } catch (error) {
    logNative(`卸载应用 requestNativeInstall 错误 ${error}`, error);
  }
}

/**
 * 获取支持静默安装的应用
 */
function* fetchSilentSoft() {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(SILENT_INSTALL_SOFT_53, { params: {} });

    if (
      res.data.status === 0 &&
      res.data.data &&
      res.data.data.silentIns &&
      res.data.data.silentIns.appInstallInfos &&
      res.data.data.silentIns.appInstallInfos.length > 0
    ) {
      const info = res.data.data.silentIns;
      const supportSilentInstSoft = [];
      info.appInstallInfos.forEach(item => {
        const itemArr = item.split('|');
        supportSilentInstSoft.push({
          softID: itemArr[0],
          silentParamDic: info.disc.silentParamDic[itemArr[1]] || null,
          silentDirParamDic: info.disc.silentDirParamDic[itemArr[2]] || null,
        });
      });
      yield put({
        type: SILENT_SOFT_INSTALL_INFOS_SUCCESS,
        supportSilentInstSoft,
        productRecommendInfo: (res.data.data && res.data.data.productRecommendInfo) || [],
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchLocalMachineInfo() {
  yield takeLatest(GET_LOCALMACHINEINFO_START, fetchLocalMachineInfo);
}

export function* watchFetchLocalSofts() {
  yield takeLatest(GET_LOCALSOFT_START, fetchLocalSofts);
}

export function* watchRequestNativeInstall() {
  yield takeLatest(REQUEST_NATIVE_INSTALL, requestNativeInstall);
}

export function* watchRequestNativeInstallList() {
  yield takeLatest(REQUEST_NATIVE_INSTALL_LIST, requestNativeInstallList);
}
export function* watchRequestNativeUninstall() {
  yield takeLatest(REQUEST_NATIVE_UNINSTALL, requestNativeUninstall);
}

export function* watchFetchSilentSoft() {
  yield takeLatest(SILENT_SOFT_INSTALL_INFOS_START, fetchSilentSoft);
}
